import classNames from "classnames";
import { Link } from "react-router-dom";

import { Icon } from "src/app/components/icon/Icon";
import logoWhite from "src/assets/logos/logo-white.png";
import { ROUTES } from "src/config/constants";

import footerCSS from "./Footer.module.css";

function Footer() {
  return (
    <footer className="u-flex u-flex-content-center u-bg-background">
      <div className={classNames("u-flex", "u-w100", "u-bg-primary-dark", footerCSS.container)}>
        <div className={classNames(footerCSS.logoWrap)}>
          <img alt="Knauf Logo" className={classNames(footerCSS.logo)} src={logoWhite} />
        </div>
        <div>
          <table>
            <tbody>
              <tr>
                <th></th>
                <th className="u-t-white u-t-align-start u-t-lh15 u-t-w700">Knauf d.o.o.</th>
              </tr>
              <tr>
                <td className="u-t-white u-t-align-start u-t-lh15 u-t-w700">Tvornica</td>
                <td className="u-t-white u-t-align-start u-t-lh15">Uzdolje polje 91, 22300 Knin</td>
              </tr>
              <tr>
                <td className="u-t-white u-t-align-start u-t-lh15 u-t-w700">Podružnica</td>
                <td className="u-t-white u-t-align-start u-t-lh15">Ulica grada Vukovara 21, 10000 Zagreb</td>
              </tr>
              <tr>
                <td className="u-t-white u-t-align-start u-t-lh15 u-t-w700">Email</td>
                <td className="u-t-white u-t-align-start">
                  <a
                    className="u-t-white u-t-w400 u-mt0 u-mb0u-t-nodecoration u-md-pb10px u-t-lh15 u-cursor-pointer"
                    href="mailto:Totem-kalkulator-upiti@knauf.com"
                  >
                    upiti-hr@knauf.com
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <Link to={ROUTES.termsAndCond} target={"_blank"} className="u-t-nodecoration u-cursor-pointer">
            <h6 className="u-t-white u-t-w400 u-m0 u-t-lh15">Pročitaj uvjete i pravila korištenja</h6>
          </Link>
          <Link to={ROUTES.privacyPolicy} target={"_blank"} className="u-t-nodecoration u-cursor-pointer">
            <h6 className="u-t-white u-t-w400 u-m0 u-t-lh15">Pročitaj privolu za obradu osobnih podataka</h6>
          </Link>
          <hr className="u-bg-white u-bt0 u-br0 u-bl0 u-border-white u-mt20px u-mb20px" />
          <div className="u-flex u-flex-row">
            <div className="u-mr30px">
              <a href="https://knauf.hr" target="_blank" rel="noreferrer" className="u-t-lh15 u-t-white u-t-nodecoration u-cursor-pointer">
                www.knauf.hr
              </a>
            </div>
            <div className="u-mr20px">
              <a className="u-t-f30p u-t-white u-cursor-pointer" rel="noreferrer" href="https://www.facebook.com/mojknauf/" target="_blank">
                <Icon name="facebook" className="u-t-valign-mid" />
              </a>
            </div>
            <div>
              <a className="u-t-f30p u-t-white u-cursor-pointer" rel="noreferrer" href="https://www.linkedin.com/company/knaufhrvatska/" target="_blank">
                <Icon name="linkedin" className="u-t-valign-mid" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
